// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper_P600l","wrapper__matrix":"style_wrapper__matrix_3p1Xu","matrix":"style_matrix_1VmfI","doteTest":"style_doteTest_2iZBO"};